import FormikControl from 'components/wrapperComponents/FormikControl';
import { msgTypes } from 'constants/msgTypes';
import { Form, Formik } from 'formik';
import { BlogModel } from 'model/screensModels/BlogModel';
import { useEffect, useRef, useState } from 'react';
import { BlogSchema } from 'schemas/menu/blog/BlogSchema';
import { BlogService } from 'services/menu/blogService/BlogService';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CreateBlog = ({ setFlag, updateRecord, loadRecentBlog }) => {
  const [viewMode, setViewMode] = useState(false);
  const [initialValue, setInitialValue] = useState(new BlogModel());
  const formikRef = useRef(null);
  const fileInputRef = useRef(null);

  const onSubmit = async (values: BlogModel) => {
    // console.log("valuess", values)
    addBlog(values)
  }

  useEffect(() => {
    if (updateRecord) {
      setInitialValue(updateRecord)
    }
  }, [updateRecord])

  //Prepare Data for API
  const prepareRequestBody = async (values: BlogModel) => {
    const prepareData = new BlogModel();

    //to assing id based on action
    if ((initialValue.blogId)?.length > 0) {
      prepareData.blogId = initialValue.blogId;
    } else {
      prepareData.blogId = values.blogId ? values.blogId : '';
    }

    prepareData.title = values.title ? values.title : '';
    prepareData.metaTitle = values.metaTitle ? values.metaTitle : '';
    prepareData.shortDescription = values.shortDescription ? values.shortDescription : '';
    prepareData.description = values.description ? values.description : '';
    prepareData.metaDescription = values.metaDescription ? values.metaDescription : '';
    prepareData.altTag = values.altTag ? values.altTag : '';
    prepareData.image = values.image ? values.image : '';

    return prepareData;
  }

  const addBlog = async (values: BlogModel) => {
    const requestData = await prepareRequestBody(values);
    const res = await BlogService.addBlog(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setInitialValue(new BlogModel());
      loadRecentBlog();
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('imageFile', null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={BlogSchema}
        onSubmit={onSubmit}
        innerRef={formikRef}
      >
        {
          ({ isValid, dirty, isSubmitting, values, setFieldValue }) => (
            
            <Form>
              <div className="row p-4 pb-0">
                <div className="col-lg-6 col-md-6 position-relative">
                  <FormikControl control='textfield'
                    name='title'
                    label="Blog Title"
                    placeholder="Enter blog title"
                    requiredField
                    disabled={viewMode}
                  />
                </div>
                <div className="col-lg-6 col-md-6 position-relative">
                  <FormikControl control='textfield'
                    name="metaTitle"
                    label="Meta Title"
                    placeholder="Enter Meta Title"
                    disabled={viewMode}
                  />
                </div>

                <div className="col-lg-6 col-md-6 position-relative">
                  <FormikControl
                    control='textfield'
                    name="shortDescription"
                    label="Short Description"
                    placeholder="Enter short description"
                    disabled={viewMode}
                  />
                </div>
                <div className="col-lg-6 col-md-6 position-relative">
                  <FormikControl control='textfield'
                    name="metaDescription"
                    label="Meta Description"
                    placeholder="Enter Meta Description"
                    disabled={viewMode}
                  />
                </div>
                <div className="col-lg-6 col-md-6 position-relative">
                  <FormikControl control='textfield'
                    name="altTag"
                    label="Alt tag"
                    placeholder="Enter Alt Tag"
                    disabled={viewMode}
                  />
                </div>
                <div className="col-lg-6 col-md-6">
                  <FormikControl
                    control="uploadImage"
                    name="imageFile"
                    label="Upload File"
                    tooltip={[msgTypes.DOCUMENT_TYPE.PDF, msgTypes.DOCUMENT_TYPE.TXT, msgTypes.DOCUMENT_TYPE.JPG,
                    msgTypes.DOCUMENT_TYPE.JPEG, msgTypes.DOCUMENT_TYPE.PNG, msgTypes.FILE_SIZE_ALLOW_3MB]}
                    nameUrl="image"
                    disabled={viewMode}
                    requiredField
                    inputRef={fileInputRef}
                  />
                </div>
                <div className="col-lg-12 mb-3 col-md-6 position-relative"
                >
                  <ReactQuill
                    value={values.description}
                    onChange={(content: any) =>  setFieldValue("description", content)}
                    placeholder="Enter Descriptions"
                    theme="snow"
                  />
                </div>
                {!viewMode ? (
                  <div className='col-12 d-flex justify-content-end'>
                    <FormikControl control='button' className="btn-submit btn" color="primary" label={values.blogId === '' ? "Save" : "Update"} type="submit" disabled={!dirty || !isValid || isSubmitting} />&nbsp;&nbsp;
                    <FormikControl control='button' className="btn-cancel btn" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />
                  </div>
                ) : null}
              </div>
            </Form>
          )
        }
      </Formik>
    </>
    
  )
}
export default CreateBlog;


